{
  "fr": {
    "aiCategories": {
      "categories": {
        "all": "Tous",
        "character": "Personas",
        "communication": "Organiser",
        "content": "Différencier",
        "featured": "Nouveau",
        "feedback": "Évaluer",
        "inspiration": "Inspirer",
        "material": "Matériaux",
        "model": "Modèle de langage",
        "null": "Non catégorisé",
        "planning": "Planification",
        "plugin": "Plugin",
        "pupils": "Élèves",
        "teachers": "Enseignant·e·s",
        "document_qa": "Assistant de documents",
        "undefined": "Non catégorisé"
      },
      "personaCategories": {
        "famousMen": "Hommes célèbres",
        "famousWomen": "Femmes célèbres",
        "funny": "Personnages fictifs amusants"
      },
      "subcategories": {
        "pupils": {
          "exercises": "Exercices et aides à l'apprentissage",
          "inspiration": "Inspiration et créativité",
          "roleplay": "Chatbot jeu de rôle"
        },
        "teachers": {
          "feedback": "Feedback et évaluation",
          "information": "Information et orientation",
          "inspiration": "Inspiration et créativité",
          "material": "Matériel et tâches",
          "administration": "Gestion et organisation scolaire",
          "planning": "Planification et organisation des cours"
        }
      }
    }
  }
}
